package com.trevorwiebe.timesheet.admin.customer.presentation

import com.trevorwiebe.timesheet.core.domain.model.Customer

enum class CustomerFilter { ACTIVE, DELETED }

data class CustomersState(
    val customers: List<Customer> = emptyList(),
    val activeFilters: Set<CustomerFilter> = setOf(CustomerFilter.ACTIVE),
    val showAddEditDialog: Boolean = false,
    val editingCustomer: Customer? = null,
    val isLoading: Boolean = false,
    val error: String? = null
)
